import React from "react";

function GetInvolved() {
  return (
    <section id="get-involved" className="get-involved">
      <div className="container">
        <h2>How You Can Help</h2>
        <p className="intro-text">
          Every action, big or small, can make a difference in the lives of animals in need. Here are some ways you can contribute to our mission.
        </p>
        <div className="options">
          <div className="option">
            <h3>Volunteer</h3>
            <p>Help at local shelters, foster animals, or support adoption events.</p>
          </div>
          <div className="option">
            <h3>Donate</h3>
            <p>Your donations fund medical care, transportation, and community outreach.</p>
          </div>
          <div className="option">
            <h3>Adopt</h3>
            <p>Give a homeless pet a loving forever home and change their life forever.</p>
          </div>
          <div className="option">
            <h3>Spread Awareness</h3>
            <p>Share our mission on social media to help us reach more people and save more lives.</p>
          </div>
        </div>
        <div className="get-involved-image">
         
        </div>
        <div className="cta-buttons">
          <a href="upi://pay?pa=7001072985@axl&pn=abhay&cu=INR&am" className="btn">Donate Now</a>
          <a href="https://chat.whatsapp.com/C75sYx7Ulid0QTO8Ad2QtS" className="btn">Become a Volunteer</a>
          <a href="https://expo.dev/accounts/abhaykeshri/projects/rehome/builds/51e0ce25-9131-45cb-9b6c-f334b3cf0205" className="btn">Find a Pet to Adopt</a>
        </div>
      </div>
    </section>
  );
}

export default GetInvolved;
